/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Kpi_DefectsInputs */

const vi_warehouse_sales_kpi_defects = /** @type {(inputs: Warehouse_Sales_Kpi_DefectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hàng lỗi (SL)`)
};

/**

* @param {Warehouse_Sales_Kpi_DefectsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_kpi_defects = /** @type {((inputs?: Warehouse_Sales_Kpi_DefectsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Kpi_DefectsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_kpi_defects(inputs)
});